import { render } from "./message-chat.vue?vue&type=template&id=4268eacb"
import script from "./message-chat.vue?vue&type=script&lang=js"
export * from "./message-chat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__